import Main from '../views/_Main.vue'
import Index from '../views/Index.vue'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  { path: '/', name: 'index', component: Index },
  { path: '/registracija', name: 'registration', component: () => import('../views/Registration.vue') },
  { path: '/prijava', name: 'login', component: () => import('../views/Login.vue') },
  {
    path: '/main',
    name: 'main',
    component: Main,
    children: [
      { path: '/porocanja/:id?', name: 'reportList', meta: { auth: true }, component: () => import('../views/ReportList.vue') },
      { path: '/porocanja/mesecno', name: 'reportMonthly', meta: { auth: true, report: true }, component: () => import('../views/ReportMonthly.vue') },
      { path: '/porocanja/popravek', name: 'reportCorrection', meta: { auth: true, report: true }, component: () => import('../views/ReportCorrection.vue') },
      { path: '/pogodbe/:id?', name: 'contractList', meta: { auth: true }, component: () => import('../views/ContractList.vue') },
      { path: '/nastavitve', name: 'userProfile', meta: { auth: true }, component: () => import('../views/UserProfile.vue') },
      {
        path: '/administracija',
        name: 'administration',
        meta: { auth: true, admin: true },
        component: () => import('../views/administration/Index.vue'),
        children: [
          { path: '/administracija/uporabniki/:id?', name: 'adminUserList', meta: { auth: true, admin: true }, component: () => import('../views/administration/UserList.vue') },
          { path: '/administracija/porocila/:id?', name: 'adminReportList', meta: { auth: true, admin: true }, component: () => import('../views/administration/ReportList.vue') },
          { path: '/administracija/pogodbe/:id?', name: 'adminContractList', meta: { auth: true, admin: true }, component: () => import('../views/administration/ContractList.vue') },
          { path: '/administracija/vsebina/:id?', name: 'adminNews', meta: { auth: true, superadmin: true }, component: () => import('../views/administration/NewsList.vue') },
          { path: '/administracija/revizijska-sled/', name: 'adminRev', meta: { auth: true, superadmin: true }, component: () => import('../views/administration/RevisionList.vue') }
        ]
      }
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: 'main' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
